<template>
  <header class="absolute top-0 w-full py-10 z-10">
    <navbar />
  </header>
</template>

<script>
import Navbar from './navbar.vue';

export default {
  components: {
    Navbar,
  },
};
</script>

<style>

</style>
